export default {
  title_one: 'Engangsbrug, {{discount}}',
  title_other: '{{count}} anvendelser, {{discount}}',
  labels: {
    fixed_discount: '{{discount}} samlet rabat',
    percentage_discount: 'Procentrabat',
  },
  buttons: {
    add_component: 'Tilføj anvendelse',
  },
};
